export const twentyFive = {
  year: "2025",
  albums: [
    {
      position: 1,
      artist: "Oklou",
      name: "choke enough",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/1e/48/ba/1e48ba16-4ee3-8ae5-742d-f6849dd8f2d7/850064074949_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 2,
      artist: "rusowsky",
      name: "DAISY",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/15/7a/b1/157ab166-5170-572f-c076-36010aad7d03/093624833734.jpg/600x600bb.jpg",
    },
    {
      position: 3,
      artist: "Parcels",
      name: "LOVED",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/17/dc/43/17dc433f-27cb-3cd7-1469-2184ae99b7b2/5056556160120_cover.jpg/600x600bb.jpg",
    },
    {
      position: 4,
      artist: "Amaia",
      name: "Si Abro Los Ojos No Es Real",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/c5/d3/82/c5d38265-9bd7-88aa-3bb3-9500eceed9d6/24UM1IM01951.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 5,
      artist: "Balu Brigada",
      name: "Portal",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/0d/32/eb/0d32eb6a-1687-8bfb-43c1-7d49864b3186/5021732825995.jpg/600x600bb.jpg",
    },
    {
      position: 6,
      artist: "CA7RIEL & Paco Amoroso",
      name: "PAPOTA",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/b1/5e/15/b15e15e0-f611-c93a-409d-e170a0e27743/196872846911.jpg/600x600bb.jpg",
    },
    {
      position: 7,
      artist: "Lorde",
      name: "Virgin",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/72/3c/07/723c07a7-4ff6-b052-927d-6997fff13676/25UMGIM60545.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 8,
      artist: "ROSALÍA",
      name: "LUX",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/95/ae/80/95ae8046-a6b9-e493-0def-5ae33d63f43a/196873722672.jpg/600x600bb.jpg",
    },
    {
      position: 9,
      artist: "Rakky Ripper",
      name: "Para que salga el Sol",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/63/c9/94/63c9944d-8f53-b3e8-c716-b4bbefc9a4f3/5034644610726.jpg/600x600bb.jpg",
    },
    {
      position: 10,
      artist: "Passengerprincess",
      name: "PASSENGERPRINCESS",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/2a/40/04/2a40046b-b036-6833-1df6-39c08d0d35ef/artwork.jpg/600x600bb.jpg",
    },
    {
      position: 11,
      artist: "Jane Remover",
      name: "Revengeseekerz",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/18/cf/f6/18cff6df-c7b6-0ca1-8067-83743f6c1f8a/193436418720_coverGriffinMcMahon.jpg/600x600bb.jpg",
    },
    {
      position: 12,
      artist: "Blood Orange",
      name: "Essex Honey",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/15/b5/61/15b56142-10d6-f9d3-f29d-e0e0d123061d/196873161457.jpg/600x600bb.jpg",
    },
    {
      position: 13,
      artist: "PinkPantheress",
      name: "Fancy That",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/12/db/5a/12db5a38-94c1-42bc-b36b-7204b7aa4eac/5021732768650.jpg/600x600bb.jpg",
    },
    {
      position: 14,
      artist: "shego",
      name: "No Lo Volveré A Hacer",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/0f/34/4e/0f344ee2-56a4-cf13-d2ca-b460fd6f9e36/8436611251050.jpg/600x600bb.jpg",
    },
    {
      position: 15,
      artist: "La Plata",
      name: "Interzona",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/d8/31/c7/d831c7d1-764d-7018-8a5b-e567c92ff3e5/25UMGIM01202.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 16,
      artist: "Tyler, The Creator",
      name: "DON'T TAP THE GLASS",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/a0/ae/e6/a0aee657-b365-fed2-249c-0f22efa507d0/196873435435.jpg/600x600bb.jpg",
    },
    {
      position: 17,
      artist: "Joey Valence & Brae",
      name: "HYPERYOUTH",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/0e/f0/e7/0ef0e779-f0cb-b783-d381-1133eb4736dc/196873327051.jpg/600x600bb.jpg",
    },
    {
      position: 18,
      artist: "Lily Allen",
      name: "West End Girl",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/d7/d9/9e/d7d99eca-a4ec-80c1-afec-379a26af58c6/4099964193565.jpg/600x600bb.jpg",
    },
    {
      position: 19,
      artist: "SPELLLING",
      name: "Portrait of My Heart",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/f9/6b/0d/f96b0d59-4c84-b47d-bd7b-480075d64992/50786.jpg/600x600bb.jpg",
    },
    {
      position: 20,
      artist: "FKA twigs",
      name: "EUSEXUA",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/ae/c8/24/aec824cf-8748-fb40-12c8-b7fb69a5ffe3/075679634382.jpg/600x600bb.jpg",
    },
    {
      position: 21,
      artist: "Racing Mount Pleasant",
      name: "Racing Mount Pleasant",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/b9/2d/4b/b92d4b0b-d8d8-fdee-b14b-2a9de71e1b2d/198704605284_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 22,
      artist: "Men I Trust",
      name: "Equus Caballus",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/66/2d/f5/662df515-7dff-1012-ccf4-08822f6ac11b/artwork.jpg/600x600bb.jpg",
    },
    {
      position: 23,
      artist: "Turnstile",
      name: "NEVER ENOUGH",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/d1/1c/28/d11c28a8-0e83-41c3-afc7-b873dd7be188/075679614896.jpg/600x600bb.jpg",
    },
    {
      position: 24,
      artist: "Addison Rae",
      name: "Addison",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/cf/4a/e3/cf4ae3c9-3420-6021-f059-cc6c87cf11b2/196872958249.jpg/600x600bb.jpg",
    },
    {
      position: 25,
      artist: "Black Country, New Road",
      name: "Forever Howlong",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/f7/08/ac/f708ac5d-4553-4253-dcd3-11c61327a532/5054429199741.png/600x600bb.jpg",
    },
  ],
};

export const twentyFour = {
  year: "2024",
  albums: [
    {
      position: 1,
      artist: "Magdalena Bay",
      name: "Imaginal Disk",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/8f/e3/6c/8fe36c7a-d280-2d0e-8e67-4ee0fd4523cd/810090095448.png/600x600bb.jpg",
    },
    {
      position: 2,
      artist: "Tyler, The Creator",
      name: "Chromakopia",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/7d/bd/e9/7dbde97e-b97d-8cc3-0203-218b687408a9/196872555059.jpg/600x600bb.jpg",
    },
    {
      position: 3,
      artist: "Charli xcx",
      name: "BRAT",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/88/4e/63/884e6321-ad41-aab1-f6f0-20efcafcfd55/075679666130.jpg/600x600bb.jpg",
    },
    {
      position: 4,
      artist: "Vampire Weekend",
      name: "Only God Was Above Us",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/f9/9f/ed/f99fed7a-3b13-3531-3db6-fac34e1d1c7c/196871790307.jpg/600x600bb.jpg",
    },
    {
      position: 5,
      artist: "Godspeed You! Black Emperor",
      name: "NO TITLE AS OF 13 FEBRUARY 2024 28,340 DEAD",
      cover: "https://f4.bcbits.com/img/a2589762612_10.jpg",
    },
    {
      position: 6,
      artist: "Ezra Collective",
      name: "Dance, No One's Watching",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/86/fd/10/86fd10b2-6f73-3c7a-9b9c-0c761a337541/0720841304906_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 7,
      artist: "Billie Eilish",
      name: "HIT ME HARD AND SOFT",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/92/9f/69/929f69f1-9977-3a44-d674-11f70c852d1b/24UMGIM36186.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 8,
      artist: "Father John Misty",
      name: "Mahashmashana",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/e5/b9/94/e5b994a7-fc83-0c5e-89db-ba03e1681a92/098787166668.png/600x600bb.jpg",
    },
    {
      position: 9,
      artist: "Remi Wolf",
      name: "Big Ideas",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/20/70/46/20704618-ab60-8777-b938-f1e748219182/24UMGIM26628.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 10,
      artist: "Georgie Greep",
      name: "The New Sound",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/80/a4/d6/80a4d66f-b8ca-ce9b-b3ad-63fe44a19704/191402049978.png/600x600bb.jpg",
    },
    {
      position: 11,
      artist: "Childish Gambino",
      name: "Bando Stone and The New World",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/3c/d3/37/3cd3376c-55f6-26ea-1dad-5d26b9391a45/196872224030.jpg/600x600bb.jpg",
    },
    {
      position: 12,
      artist: "Carolina Durante",
      name: "Elige Tu Propia Aventura",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/8d/16/bd/8d16bd21-83d6-6573-2e1a-7664593a04ab/24UMGIM50010.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 13,
      artist: "Hildegard",
      name: "Jour 1596",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/4f/7c/98/4f7c9860-da28-ebfc-9397-afe10ac30010/cover.jpg/600x600bb.jpg",
    },
    {
      position: 14,
      artist: "Jamie xx",
      name: "In Waves",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/3d/71/8e/3d718e96-3a34-69bd-8d68-0798d5a8c180/889030041579.png/600x600bb.jpg",
    },
    {
      position: 15,
      artist: "AURORA",
      name: "What Happened To The Heart?",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/66/97/85/66978511-3fbd-7c77-756d-187b9705c6a6/198391581359.jpg/600x600bb.jpg",
    },
    {
      position: 16,
      artist: "Biznaga",
      name: "¡AHORA!",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/b6/22/d0/b622d051-b415-62ba-e072-1dcb985c220e/8426946909573_3000.jpg/600x600bb.jpg",
    },
    {
      position: 17,
      artist: "Beth Gibbons",
      name: "Lives Outgrown",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/f0/d6/17/f0d61779-8700-b06b-fee2-18375aee8bee/887828028764.png/600x600bb.jpg",
    },
    {
      position: 18,
      artist: "Laura Marling",
      name: "Patterns In Repeat",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/93/0d/11/930d11ad-a233-8f14-497c-3635157d7ad7/46855.jpg/600x600bb.jpg",
    },
    {
      position: 19,
      artist: "St. Vincent",
      name: "All Born Screaming",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/6d/00/8c/6d008c01-074d-e2af-c691-943a155e4a60/00196922832147_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 20,
      artist: "Doechii",
      name: "Alligator Bites Never Heal",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/b0/6e/78/b06e7807-f9ef-7f76-faa8-8d1a01d6d877/24UMGIM88643.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 21,
      artist: "The Dare",
      name: "What's Wrong With New York?",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/f0/89/da/f089da91-f8d1-61b9-8110-5a4194973704/24UMGIM64117.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 22,
      artist: "RM",
      name: "Right Place, Wrong Person",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/65/8e/78/658e78ae-253d-2b9c-ed83-3f623e607d36/196922948947_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 23,
      artist: "CA7RIEL & Paco Amoroso",
      name: "BAÑO MARÍA",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/46/c3/e5/46c3e52f-429e-555a-9db1-effa8565faf1/196871931229.jpg/600x600bb.jpg",
    },
    {
      position: 24,
      artist: "Empress Of",
      name: "For Your Consideration",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/2b/d2/a7/2bd2a73d-a589-6b14-b8fc-55d96c6e3aa1/8721056032037.png/600x600bb.jpg",
    },
    {
      position: 25,
      artist: "Allie X",
      name: "Girl With No Face",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/f7/55/f8/f755f8c6-d48a-682f-4f8a-d6bf2168cce0/197190189131.jpg/600x600bb.jpg",
    },
  ],
};

export const twentyThree = {
  year: "2023",
  albums: [
    {
      position: 1,
      artist: "Caroline Polacheck",
      name: "Desire, I Want To Turn Into You",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/10/51/f2/1051f2cc-195f-ddb6-2d9e-26c74f0387fd/197187988518.jpg/600x600bb.jpg",
    },
    {
      position: 2,
      artist: "Sufjan Stevens",
      name: "Javelin",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/80/e9/61/80e96151-6e40-6daf-bdc6-33dbb65510e6/40697.jpg/600x600bb.jpg",
    },
    {
      position: 3,
      artist: "Boygenius",
      name: "the record",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music123/v4/ad/fc/81/adfc819e-00b2-3cb5-deb2-931a5b6da3fa/22UM1IM44998.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 4,
      artist: "Black Country, New Road",
      name: "Live At Bush Hall",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/36/ff/fb/36fffb75-8489-2baf-8288-473adff6f46f/5054429172508.png/600x600bb.jpg",
    },
    {
      position: 5,
      artist: "María José Llergo",
      name: "ULTRABELLEZA",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/8e/cb/ce/8ecbce22-8da5-3ebf-42cb-76a029c65692/196871235730.jpg/600x600bb.jpg",
    },
    {
      position: 6,
      artist: "PinkPantheress",
      name: "Heaven knows",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/05/59/17/0559179a-9f72-3384-2bc0-ebfee2c5c9e3/5054197835070.jpg/600x600bb.jpg",
    },
    {
      position: 7,
      artist: "Hannah Diamond",
      name: "Perfect Picture",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/ae/1f/26/ae1f2659-827d-8cf7-cd2a-1586c288c59c/196922550393_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 8,
      artist: "Janelle Monáe",
      name: "The Age Of Pleasure",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/0f/d6/08/0fd608cf-086d-b6da-ea29-a4591601ebc0/075679690227.jpg/600x600bb.jpg",
    },
    {
      position: 9,
      artist: "Mitski",
      name: "The Land Is Inhospitable and So Are We",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/8f/4b/40/8f4b4044-d02b-dc25-7d01-7d9d225fdce4/40240.jpg/600x600bb.jpg",
    },
    {
      position: 10,
      artist: "100 Gecs",
      name: "10,000 Gecs",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/7b/16/c9/7b16c9c2-a738-66c6-0476-65f020d5dc24/075679708069.jpg/600x600bb.jpg",
    },
    {
      position: 11,
      artist: "Rakky Ripper",
      name: "NADIE LO VA A HACER POR MI",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/da/6f/5f/da6f5f66-8ea4-6bf5-e075-f523a5ab8ff2/197338239247.jpg/600x600bb.jpg",
    },
    {
      position: 12,
      artist: "Chappell Roan",
      name: "The Rise and Fall of a Midwest Princess",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/fb/65/cb/fb65cb0f-4260-d740-d6f5-bb80c9c27c1b/23UMGIM84225.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 13,
      artist: "Slayyyter",
      name: "STARFUCKER",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/19/d6/e0/19d6e085-9c51-a3cc-5532-a60eed1b4a90/23SYMIM05623.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 14,
      artist: "James Blake",
      name: "Playing Robots Into Heaven",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/ac/df/31/acdf31ba-ed8c-36c8-55fa-4fea81cf8395/23UMGIM73095.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 15,
      artist: "The Chemical Brothers",
      name: "For That Beautiful Feeling",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/94/cb/82/94cb8213-d81a-d5f4-39a4-723d7813f2e7/23UMGIM30024.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 16,
      artist: "Thy Slaughter, A.G. Cook & EASYFUN",
      name: "Soft Rock",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/50/79/a1/5079a1fc-c285-2bf4-0607-34b12b6209c7/196922705571_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 17,
      artist: "The Japansese House",
      name: "In The End It Always Does",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music112/v4/36/c4/e0/36c4e01c-8e41-9379-fce1-48f784d5f134/196922296680_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 18,
      artist: "Lana Del Rey",
      name: "Did you know that there's a tunnel under Ocean Blvd",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music113/v4/7c/c4/e5/7cc4e501-6b09-b379-bb54-a40de4615aa3/22UM1IM33313.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 19,
      artist: "Olivia Rodrigo",
      name: "GUTS",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/9b/d8/9c/9bd89c9e-b44d-ad25-1516-b9b30f64fd2a/23UMGIM71510.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 20,
      artist: "Jorja Smith",
      name: "falling or flying",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/67/04/be/6704be3f-90ef-267b-c677-29f78c3f36ea/197188272494.jpg/600x600bb.jpg",
    },
    {
      position: 21,
      artist: "Sigur Rós",
      name: "ÁTTA",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/f0/ec/d2/f0ecd2d3-6dd0-dda8-2a16-0b74c0a5260f/4050538920437.jpg/600x600bb.jpg",
    },
    {
      position: 22,
      artist: "Lil Yatchy",
      name: "Let's Start Here",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music123/v4/ea/42/e0/ea42e096-991f-eff5-ae81-b67bd9fdd1c4/22UM1IM13152.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 23,
      artist: "_juno",
      name: "_BCN747",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music113/v4/75/76/b2/7576b293-2c3c-063a-5b61-a956eea7b5e1/8445162792394.jpg/600x600bb.jpg",
    },
    {
      position: 24,
      artist: "Arlo Parks",
      name: "My Soft Machine",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music123/v4/be/dd/e3/bedde35d-a3dc-6d1c-7b4b-e69911aa5fad/5400863101916_cover.jpg/600x600bb.jpg",
    },
    {
      position: 25,
      artist: "María Escarmiento",
      name: "☆ COSAS DE BRUJAS ☆",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/99/c5/80/99c58084-6dc1-7ad9-539f-36b6fb44ff31/197338947388.jpg/600x600bb.jpg",
    },
  ],
};

export const twentyTwo = {
  year: "2022",
  albums: [
    {
      position: 1,
      artist: "The 1975",
      name: "Being Funny In A Foreign Language",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music112/v4/ec/35/84/ec35841a-f7d1-71dd-fcb8-38e8f6c62d83/196922101519_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 2,
      artist: "Rosalía",
      name: "MOTOMAMI",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/5b/da/8d/5bda8d04-7f2f-4417-12a0-e039dd011152/886449800193.jpg/600x600bb.jpg",
    },
    {
      position: 3,
      artist: "Black Country, New Road",
      name: "Ants From Up There",
      cover:
        "https://is5-ssl.mzstatic.com/image/thumb/Music112/v4/3e/83/4f/3e834feb-a778-0df8-6c1b-83afddc888da/5054429151442.png/600x600bb.jpg",
    },
    {
      position: 4,
      artist: "Rina Sawayama",
      name: "Hold The Girl",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/74/33/5c/74335c27-4a6e-fe68-af7b-871e5cbf104d/196922042713_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 5,
      artist: "Charli XCX",
      name: "CRASH",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/7c/81/6d/7c816d0a-0745-350a-365e-ff4089af7e92/190296409165.jpg/600x600bb.jpg",
    },
    {
      position: 6,
      artist: "SZA",
      name: "SOS",
      cover:
        "https://is2-ssl.mzstatic.com/image/thumb/Music122/v4/bd/3b/a9/bd3ba9fb-9609-144f-bcfe-ead67b5f6ab3/196589564931.jpg/600x600bb.jpg",
    },
    {
      position: 7,
      artist: "Ethel Cain",
      name: "Preacher's Daughter",
      cover:
        "https://is5-ssl.mzstatic.com/image/thumb/Music122/v4/a7/ed/58/a7ed5868-e006-c8cb-5283-e138ea399701/5056167172390_1.jpg/600x600bb.jpg",
    },
    {
      position: 8,
      artist: "Weyes Blood",
      name: "And In The Darkness, Hearts Aglow",
      cover:
        "https://is5-ssl.mzstatic.com/image/thumb/Music112/v4/63/a6/b9/63a6b9df-ec97-abc7-f96f-f200e2a85c69/098787148565.png/600x600bb.jpg",
    },
    {
      position: 9,
      artist: "Mitski",
      name: "Laurel Hell",
      cover:
        "https://is2-ssl.mzstatic.com/image/thumb/Music115/v4/fe/01/99/fe019995-88e4-9e5c-9621-d28953dc9aa5/27273.jpg/600x600bb.jpg",
    },
    {
      position: 10,
      artist: "Taylor Swift",
      name: "Midnights",
      cover:
        "https://is3-ssl.mzstatic.com/image/thumb/Music122/v4/8b/59/4b/8b594b75-5a1a-9a39-e003-b227d09d5b37/22UM1IM07364.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 11,
      artist: "Biznaga",
      name: "Bremen No Existe",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/1b/37/74/1b37747d-11ac-9fb4-3f1c-7ef5a707ad97/8426946908750_3000.jpg/600x600bb.jpg",
    },
    {
      position: 12,
      artist: "Arcade Fire",
      name: "WE",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/29/7f/0f/297f0f87-fda5-db4b-4103-5bca480f5043/886449956630.jpg/600x600bb.jpg",
    },
    {
      position: 13,
      artist: "Beyoncé",
      name: "RENAISSANCE",
      cover:
        "https://is2-ssl.mzstatic.com/image/thumb/Music112/v4/05/05/f3/0505f338-9873-feb4-af7f-27a470405e5f/196589246974.jpg/600x600bb.jpg",
    },
    {
      position: 14,
      artist: "First Aid Kit",
      name: "Palomino",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/32/e4/31/32e4314b-8a78-2486-b0b7-d40aa5997eca/196589329295.jpg/600x600bb.jpg",
    },
    {
      position: 15,
      artist: "Fred Again..",
      name: "Actual Life 3 (January 1 - September 9 2022)",
      cover:
        "https://is3-ssl.mzstatic.com/image/thumb/Music122/v4/b0/9c/b7/b09cb72c-cca9-5d66-bc9d-a9b5e5f86b22/5054197236389.jpg/600x600bb.jpg",
    },
    {
      position: 16,
      artist: "BROCKHAMPTON",
      name: "TM",
      cover:
        "https://is3-ssl.mzstatic.com/image/thumb/Music122/v4/94/a0/10/94a01075-8125-c028-cd36-863cf97c873a/196589446497.jpg/600x600bb.jpg",
    },
    {
      position: 17,
      artist: "Kendrick Lamar",
      name: "Mr. Morale & The Big Steppers",
      cover:
        "https://is5-ssl.mzstatic.com/image/thumb/Music116/v4/72/a1/a9/72a1a9a0-6c42-a37f-aad4-7e8772365c6d/22UMGIM52376.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 18,
      artist: "Arctic Monkeys",
      name: "The Car",
      cover:
        "https://is5-ssl.mzstatic.com/image/thumb/Music122/v4/0f/03/0f/0f030fb9-a529-dba5-4e9d-4fbf2ed25037/887828045563.png/600x600bb.jpg",
    },
    {
      position: 19,
      artist: "Marcus Mumford",
      name: "(self-titled)",
      cover:
        "https://is3-ssl.mzstatic.com/image/thumb/Music122/v4/c9/ef/d7/c9efd7c5-6256-09f3-d41e-e8a4d08fb783/22UMGIM64225.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 20,
      artist: "MUNA",
      name: "MUNA",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/65/5f/7f/655f7f7b-25d8-40de-465c-8c8348919e1d/31341.jpg/600x600bb.jpg",
    },
    {
      position: 21,
      artist: "Carly Rae Jepsen",
      name: "The Loneliest Time",
      cover:
        "https://is2-ssl.mzstatic.com/image/thumb/Music112/v4/87/44/c7/8744c742-9701-eff8-53a5-269f1f055376/22UMGIM84738.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 22,
      artist: "Hard Life",
      name: "MAYBE IN ANOTHER LIFE...",
      cover:
        "https://is2-ssl.mzstatic.com/image/thumb/Music122/v4/93/21/9b/93219b45-7dd0-b9b3-d9c1-da81a1fce111/22UMGIM40455.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 23,
      artist: "Father John Misty",
      name: "Chloë and the Next 20th Century",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/b8/84/e4/b884e448-58f2-ca3c-34b3-c604bddb5ba8/098787143065.png/600x600bb.jpg",
    },
    {
      position: 24,
      artist: "Shygirl",
      name: "Nymph",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music112/v4/dd/50/2a/dd502a01-fe53-3529-3a3e-d080c0a46546/5056556107729_cover.jpg/600x600bb.jpg",
    },
    {
      position: 25,
      artist: "Florence + The Machine",
      name: "Dance Fever",
      cover:
        "https://is5-ssl.mzstatic.com/image/thumb/Music116/v4/93/ce/c5/93cec50d-bb01-3a42-364a-54af31cd73c7/22UMGIM23127.rgb.jpg/600x600bb.jpg",
    },
  ],
};

export const twentyOne = {
  year: "2021",
  albums: [
    {
      position: 1,
      artist: "Billie Eillish",
      name: "Happier Than Ever",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/2d/f3/c9/2df3c9fd-e0eb-257c-c035-b04f05a66580/21UMGIM36691.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 2,
      artist: "Spellling",
      name: "The Turning Wheel",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/7c/b1/14/7cb1149a-717e-f350-dd9c-98d38cd5c0d7/843563136294.jpg/600x600bb.jpg",
    },
    {
      position: 3,
      artist: "Tyler, The Creator",
      name: "CALL ME IF YOU GET LOST",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/65/47/0a/65470a4c-a70f-4a0b-f77b-3edb39e9097a/886449377039.jpg/600x600bb.jpg",
    },
    {
      position: 4,
      artist: "Zahara",
      name: "PUTA",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/91/38/1d/91381dd2-5237-63be-a9bc-3833393e9a89/8445162368735.jpg/600x600bb.jpg",
    },
    {
      position: 5,
      artist: "Olivia Rodrigo",
      name: "SOUR",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/ce/63/06/ce6306bb-5830-af8f-8ebd-4eb7d3c14e1e/21UMGIM26092.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 6,
      artist: "Kacey Musgraves",
      name: "star-crossed",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/41/66/82/41668228-8392-9498-a66a-6b2179222bd4/21UMGIM43953.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 7,
      artist: "Bleachers",
      name: "Take The Saddness Out Of Saturday Night",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/87/b4/90/87b49017-ae3f-888a-0d0c-bab4eaeb1077/886449225101.jpg/600x600bb.jpg",
    },
    {
      position: 8,
      artist: "Porter Robinson",
      name: "Nurture",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/e7/e7/f7/e7e7f72a-431f-1819-e46e-d3584047125a/858275061918.png/600x600bb.jpg",
    },
    {
      position: 9,
      artist: "La M.O.D.A.",
      name: "Nuevo Cancionero Burgalés",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/28/49/ed/2849ed88-d1c5-2f75-3e7f-fe7658257cd4/25UMGIM75698.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 10,
      artist: "Zara Larsson",
      name: "Poster Girl",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/6a/10/cd/6a10cdce-c59e-7a30-0121-571f699acde9/886449023707.jpg/600x600bb.jpg",
    },
    {
      position: 11,
      artist: "Tu Suerte",
      name: "Esto Es Para Ti",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/82/69/49/82694937-ccea-a66f-80de-7b0bb3b36cff/91578.jpg/600x600bb.jpg",
    },
    {
      position: 12,
      artist: "Little Simz",
      name: "Sometimes I Might Be Introvert",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/08/14/88/0814883a-444f-6447-3eec-6753eb129d5e/5056167162674_1.jpg/600x600bb.jpg",
    },
    {
      position: 13,
      artist: "No Rome",
      name: "It's All Smiles",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/95/af/2d/95af2d3f-a8d2-25ca-6771-18554b634746/192641830969_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 14,
      artist: "FINNEAS",
      name: "Optimist",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/10/75/23/107523a8-f705-f95d-9374-62f0eb24b782/21UMGIM70157.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 15,
      artist: "Chvrches",
      name: "Screen Violence",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/22/27/55/222755ea-c652-807f-e95f-7a0812265dc9/5056167164074.jpg/600x600bb.jpg",
    },
    {
      position: 16,
      artist: "Villagers",
      name: "Fever Dreams",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music112/v4/8e/85/5c/8e855c5c-69ab-cde9-113b-931c69dba67a/887835053261.png/600x600bb.jpg",
    },
    {
      position: 17,
      artist: "Lucy Dacus",
      name: "Home Video",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/cb/cb/24/cbcb2433-3345-dfcb-9357-949bcb1cf883/191401173674.png/600x600bb.jpg",
    },
    {
      position: 18,
      artist: "Alavedra",
      name: "Uf Venga",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/aa/81/30/aa8130c2-bcf1-7317-36ac-2e9c1390256e/196006363925.jpg/600x600bb.jpg",
    },
    {
      position: 19,
      artist: "Jónsi",
      name: "Obsidian",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/93/8b/8b/938b8b5d-1022-414f-995e-a25608fc68c3/17251.jpg/600x600bb.jpg",
    },
    {
      position: 20,
      artist: "Japanese Breakfast",
      name: "Jubilee",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music126/v4/93/8b/8b/938b8b5d-1022-414f-995e-a25608fc68c3/17251.jpg/600x600bb.jpg",
    },
    {
      position: 21,
      artist: "Chloe Moriondo",
      name: "Blood Bunny",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/87/5c/bf/875cbff7-a8f7-fc4f-808c-458bb139ce26/075679787859.jpg/600x600bb.jpg",
    },
    {
      position: 22,
      artist: "Hard Life",
      name: "life's a beach",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/76/b7/8a/76b78af6-57bd-7994-e715-f191f3408ca1/20UM1IM08220.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 23,
      artist: "Arlo Parks",
      name: "Collapsed In Sunbeams",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/77/f1/75/77f17596-3e4e-ea12-011a-263327d1cf38/5400863095055_cover.jpg/600x600bb.jpg",
    },
    {
      position: 24,
      artist: "PinkPantheress",
      name: "to hell with it",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/ae/c0/64/aec064da-83cc-4ce9-fcdc-19bd62800109/190296429699.jpg/600x600bb.jpg",
    },
    {
      position: 25,
      artist: "Coldplay",
      name: "Music Of The Spheres",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/df/60/00/df600071-c5c7-24e7-e4d7-1a6b71fa44e7/190296529818.jpg/600x600bb.jpg",
    },
  ],
};

export const twenty = {
  year: "2020",
  albums: [
    {
      position: 1,
      artist: "Phoebe Bridgers",
      name: "Punisher",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/39/91/4f/39914f60-e9aa-4ae9-3962-44b0a5e5d570/656605150062.jpg/600x600bb.jpg",
    },
    {
      position: 2,
      artist: "Taylor Swift",
      name: "folklore",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/b5/80/dc/b580dca0-349d-036b-e09b-bd849f6affd8/20UMGIM64216.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 3,
      artist: "The Strokes",
      name: "The New Abnormal",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/62/a6/ff/62a6ff2a-95c9-5302-31f4-2dcca9e40323/886448281085.jpg/600x600bb.jpg",
    },
    {
      position: 4,
      artist: "Jónsi",
      name: "Shiver",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music113/v4/18/ae/d4/18aed431-16ab-e600-45a4-5fb328d4b664/190296831744.jpg/600x600bb.jpg",
    },
    {
      position: 5,
      artist: "Viva Belgrado",
      name: "Bellavista",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/0f/49/34/0f49340b-6eaa-2ff0-d5f2-e72402535d27/8447181099492.jpg/600x600bb.jpg",
    },
    {
      position: 6,
      artist: "Taylor Swift",
      name: "evermore",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/44/e3/94/44e3945f-d613-09f8-538a-aba063d59358/20UM1IM14847.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 7,
      artist: "Declan McKenna",
      name: "Zeros",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music123/v4/3e/a7/90/3ea7900e-1d1f-2cfb-5a9c-6a1268cef5dd/850007715830.jpg/600x600bb.jpg",
    },
    {
      position: 8,
      artist: "The Koreatown Oddity",
      name: "Little Dominiques Nosebleed",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/9d/77/69/9d77696b-801d-2468-e66f-3e0facb7818f/912.jpg/600x600bb.jpg",
    },
    {
      position: 9,
      artist: "The Avalanches",
      name: "We Will Always Love You",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/5d/5f/a7/5d5fa749-4edf-a628-61e2-a75d6d94de4b/20UMGIM73870.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 10,
      artist: "Against All Logic",
      name: "2017-2019",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/a8/49/84/a849847d-9683-9a8b-70c2-b7bfa3257973/193436411332_AALblurredbarcode.jpg/600x600bb.jpg",
    },
    {
      position: 11,
      artist: "Bad Bunny",
      name: "YHLQMDLG",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/8c/0f/81/8c0f81f2-9f10-5e3d-b9de-5961a73e8e52/195081078724.jpg/600x600bb.jpg",
    },
    {
      position: 12,
      artist: "Nothing But Thieves",
      name: "Moral Panic",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/73/92/05/73920581-0801-84b2-bd1c-7f802696dcde/886448371342.jpg/600x600bb.jpg",
    },
    {
      position: 13,
      artist: "Charli XCX",
      name: "how i'm feeling now",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/1a/5c/e9/1a5ce93c-aef4-6667-b7d1-7162203e1c39/190295229993.jpg/600x600bb.jpg",
    },
    {
      position: 14,
      artist: "beabadoobee",
      name: "Fake It Flowers",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/b0/d7/f8/b0d7f88c-58e3-5644-225b-ad38d7b23a4d/192641596216_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 15,
      artist: "Black Pumas",
      name: "Black Pumas",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/83/80/ea/8380ea4b-ba34-30b4-43eb-ce57fb9e8f82/739.jpg/600x600bb.jpg",
    },
    {
      position: 16,
      artist: "HAIM",
      name: "Women In Music Pt. III",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/82/93/e6/8293e604-dae8-71e6-cd66-72e7308488f9/886448286899.jpg/600x600bb.jpg",
    },
    {
      position: 17,
      artist: "Fiona Apple",
      name: "Fetch The Bolt Cutters",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/55/b8/12/55b81281-ec56-0bc5-5628-030e683ff7c9/886448398486.jpg/600x600bb.jpg",
    },
    {
      position: 18,
      artist: "Khruangbin",
      name: "Mordechai",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/94/a7/44/94a74465-1fe9-b897-a1ed-99b2e5b3b497/656605149363.jpg/600x600bb.jpg",
    },
    {
      position: 19,
      artist: "Cave People",
      name: "Looking",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/b0/27/3a/b0273a84-ae09-03da-43b6-078c55297f44/859741564124_cover.jpg/600x600bb.jpg",
    },
    {
      position: 20,
      artist: "La M.O.D.A.",
      name: "Ninguna Ola",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/86/b5/20/86b520b1-27c8-1166-1b6d-ab545b1ec673/25UMGIM75691.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 21,
      artist: "King Gizzard & The Lizard Wizard",
      name: "K.G.",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/a3/fa/11/a3fa115d-7e67-0cd5-61da-c85cb7d93641/20UMGIM78804.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 22,
      artist: "Will Butler",
      name: "Generations",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/2b/ed/c4/2bedc494-dd87-edf7-988e-3b14dd8e910b/56713.jpg/600x600bb.jpg",
    },
    {
      position: 23,
      artist: "Christine And The Queens",
      name: "La Vita Nuova",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/fd/c5/14/fdc51434-dbe9-81a8-f0fc-c14365121bcc/5060899070220_cover.jpg/600x600bb.jpg",
    },
    {
      position: 24,
      artist: "Gorillaz",
      name: "Song Machine, Season 1: Strange Timez",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/01/d6/6e/01d66e09-0bcc-c560-469b-f6f3af6124b6/190295143152.jpg/600x600bb.jpg",
    },
    {
      position: 25,
      artist: "Nathy Peluso",
      name: "CALAMBRE",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/e9/16/69/e91669b1-53be-1516-a632-6ce93891c101/886448636915.jpg/600x600bb.jpg",
    },
  ],
};

export const nineteen = {
  year: "2019",
  albums: [
    {
      position: 1,
      artist: "Caroline Polacheck",
      name: "Pang",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/bb/54/70/bb547075-db39-9b4c-5099-00655f917189/886447908150.jpg/600x600bb.jpg",
    },
    {
      position: 2,
      artist: "Charli XCX",
      name: "Charli",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/b9/2e/17/b92e178e-96d8-ae48-5083-0c86267f2be1/190295409562.jpg/600x600bb.jpg",
    },
    {
      position: 3,
      artist: "American Football",
      name: "LP3",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/f7/b4/58/f7b45841-de5c-d66b-d066-208f6886928c/644110037497.png/600x600bb.jpg",
    },
    {
      position: 4,
      artist: "FOALS",
      name: "Everything Not Saved Will Be Lost Part I",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/51/08/ca/5108ca93-7c84-e999-5750-6bf66e6c94c9/190295005832.jpg/600x600bb.jpg",
    },
    {
      position: 5,
      artist: "La Casa Azul",
      name: "La Gran Esfera",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/12/5b/ce/125bcee5-e12c-c4ae-c3b2-84144343f002/ER-1240.jpg/600x600bb.jpg",
    },
    {
      position: 6,
      artist: "Vampire Weekend",
      name: "Father Of The Bride",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/8d/51/fd/8d51fdc8-1924-92f4-4603-4b50f93acda5/886448304548.jpg/600x600bb.jpg",
    },
    {
      position: 7,
      artist: "Of Monsters And Men",
      name: "FEVER DREAM",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/f8/30/74/f8307479-0f9d-85d8-a430-b6e488344478/19UMGIM38568.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 8,
      artist: "Friendly Fires",
      name: "Inflorescent",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/c1/5a/43/c15a43fb-bc5f-1166-13c3-4ddba44b8068/19UMGIM50790.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 9,
      artist: "SYML",
      name: "SYML",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/fc/6d/85/fc6d855f-caf3-e0b0-95e9-e37ae5c5bc81/067003118651.png/600x600bb.jpg",
    },
    {
      position: 10,
      artist: "The Lumineers",
      name: "III",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/72/54/2e/72542e50-7426-100d-e3ac-782fcbca223e/18577.jpg/600x600bb.jpg",
    },
    {
      position: 11,
      artist: "Coldplay",
      name: "Everyday Life",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music123/v4/c0/19/69/c0196997-ea66-9577-e894-022b1caf3e4f/190295323929.jpg/600x600bb.jpg",
    },
    {
      position: 12,
      artist: "The Chemical Brothers",
      name: "No Geography",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/65/20/7a/65207a0f-88d6-6808-e4d4-bdf814490f4b/00602577080241.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 13,
      artist: "Tiny Moving Parts",
      name: "breathe",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music123/v4/a2/2f/b1/a22fb1bd-b77c-75cb-7643-5d41101335d0/TMP_BREATHE_300DPI.jpg/600x600bb.jpg",
    },
    {
      position: 14,
      artist: "Harry Styles",
      name: "Fine Line",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/2b/c4/c9/2bc4c9d4-3bc6-ab13-3f71-df0b89b173de/886448022213.jpg/600x600bb.jpg",
    },
    {
      position: 15,
      artist: "Avey Tare",
      name: "Cows On Hourglass Pond",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/ac/a6/81/aca68123-53ec-2508-e001-a6b5b9c0fed6/887828044764.png/600x600bb.jpg",
    },
    {
      position: 16,
      artist: "The Regrettes",
      name: "How Do You Love?",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music123/v4/40/6c/33/406c3358-30b7-fe03-6178-ec52ad325ac5/093624900108.jpg/600x600bb.jpg",
    },
    {
      position: 17,
      artist: "half·alive",
      name: "Now, Not Yet",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/d9/f5/5d/d9f55d68-c60b-e3ce-559d-75cd63a7f591/886447791950.jpg/600x600bb.jpg",
    },
    {
      position: 18,
      artist: "The S.L.P.",
      name: "The S.L.P.",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music113/v4/0c/7f/76/0c7f7666-7e86-9d5b-2df4-4bc4f9454d6a/886447640197.jpg/600x600bb.jpg",
    },
    {
      position: 19,
      artist: "Mark Ronson",
      name: "Late Night Feelings",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/e0/80/ef/e080ef9c-23ea-de9e-5d09-b4780df4c022/886447539873.jpg/600x600bb.jpg",
    },
    {
      position: 20,
      artist: "Kanye West",
      name: "Jesus Is King",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music113/v4/21/fd/d3/21fdd3d4-0c00-53ef-3903-d0569c49a812/19UMGIM89397.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 21,
      artist: "FOALS",
      name: "Everything Not Saved Will Be Lost Part II",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/85/a0/40/85a04059-be85-eae0-c9b8-0aa59cfe1614/190295005825.jpg/600x600bb.jpg",
    },
    {
      position: 22,
      artist: "Taylor Swift",
      name: "Lover",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/49/3d/ab/493dab54-f920-9043-6181-80993b8116c9/19UMGIM53909.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 23,
      artist: "Amaia",
      name: "Pero No Pasa Nada",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music113/v4/f5/cd/6c/f5cd6cfa-330a-7668-82dc-9841123d62ca/19UMGIM56398.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 24,
      artist: "Cage The Elephant",
      name: "Social Cues",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/e9/31/cc/e931cc5a-e541-5348-b601-1a3053474acb/886447488812.jpg/600x600bb.jpg",
    },
    {
      position: 25,
      artist: "The Amazons",
      name: "Future Dust",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/7f/93/6b/7f936b18-43ee-6adc-1979-73828a30d835/19UMGIM18626.rgb.jpg/600x600bb.jpg",
    },
  ],
};

export const eighteen = {
  year: "2018",
  albums: [
    {
      position: 1,
      artist: "Rosalía",
      name: "El Mal Querer",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/2c/55/e1/2c55e13f-15d8-1c7c-1826-c5fa55deaa8f/886447217139.jpg/600x600bb.jpg",
    },
    {
      position: 2,
      artist: "First Aid Kit",
      name: "Ruins",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/b1/4b/87/b14b873c-e987-b447-fbf7-9793b939f8db/886446818238.jpg/600x600bb.jpg",
    },
    {
      position: 3,
      artist: "Against All Logic",
      name: "2012-2017",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/8d/1e/18/8d1e1896-902b-3b50-2163-a01e097daece/193436434744_AAL.jpg/600x600bb.jpg",
    },
    {
      position: 4,
      artist: "The 1975",
      name: "A Brief Inquiry Into Online Relationships",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/ea/24/e2/ea24e228-6bf1-625a-11dc-d83d5ee780e6/18UMGIM53788.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 5,
      artist: "Zahara",
      name: "Astronauta",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music118/v4/64/a0/4f/64a04f57-a29d-cf92-4abc-e2772234dc53/8429006298556.jpg/600x600bb.jpg",
    },
    {
      position: 6,
      artist: "KIDS SEE GHOSTS",
      name: "KIDS SEE GHOSTS",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music124/v4/2c/bc/1c/2cbc1cca-7881-2605-875c-536f553cc79a/00602567803881.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 7,
      artist: "Tropical Fuck Storm",
      name: "A Laughing Death In Meatspace",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music128/v4/07/05/b2/0705b26e-4ec9-a699-bedf-174fd68aceda/714270693403.jpg/600x600bb.jpg",
    },
    {
      position: 8,
      artist: "Jeff Rosenstock",
      name: "POST-",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/0a/38/58/0a3858be-0b83-f047-5ca6-c46c5197ebd1/644110035394.png/600x600bb.jpg",
    },
    {
      position: 9,
      artist: "Charlie Barnes",
      name: "Oceanography",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music62/v4/76/54/8a/76548a09-6f3b-d483-bc87-2449d8bab985/886446879680.jpg/600x600bb.jpg",
    },
    {
      position: 10,
      artist: "Varry Brava",
      name: "Furor",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music118/v4/9a/1a/4f/9a1a4fa8-a737-cc6e-ca7e-c4c5a146f867/8429006145096.jpg/600x600bb.jpg",
    },
    {
      position: 11,
      artist: "Arctic Monkeys",
      name: "Tranquility Base Hotel & Casino",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/f3/ac/06/f3ac06b3-9217-adc8-cc33-8e930293e495/887835044184.png/600x600bb.jpg",
    },
    {
      position: 12,
      artist: "Gorillaz",
      name: "The Now Now",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/c8/a2/c0/c8a2c0cc-28e9-c0c6-f425-f6aaf13191f4/190295620660.jpg/600x600bb.jpg",
    },
    {
      position: 13,
      artist: "IZAL",
      name: "Autoterapia",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music118/v4/b8/58/c1/b858c118-a93d-60f1-5984-e17aa06e3abd/8429006160846.jpg/600x600bb.jpg",
    },
    {
      position: 14,
      artist: "Noah Cyrus",
      name: "Good Cry",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music118/v4/88/cb/0d/88cb0dee-0ed2-8f26-adc3-075fe9d4f8f4/886447314371.jpg/600x600bb.jpg",
    },
    {
      position: 15,
      artist: "Dorian",
      name: "Justicia Universal",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music118/v4/9f/25/2a/9f252a9a-2afd-3f17-b00d-2418795c230f/192562505489.jpg/600x600bb.jpg",
    },
    {
      position: 16,
      artist: "Khruangbin",
      name: "Con Todo El Mundo",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/17/67/2e/17672e3b-9d01-2d5e-9b43-38f44b40f654/656605145365.jpg/600x600bb.jpg",
    },
    {
      position: 17,
      artist: "Boy Pablo",
      name: "Soy Pablo",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music115/v4/56/25/dc/5625dcd5-7e97-6dc7-6421-1bbb9dd7d0c4/192641179129_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 18,
      artist: "Chvrches",
      name: "Love Is Dead",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/01/93/fa/0193fa8b-d009-c675-04c6-4ad3b6b17cdc/44003194212.jpg/600x600bb.jpg",
    },
    {
      position: 19,
      artist: "Mumford & Sons",
      name: "Delta",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/54/54/14/5454144c-37a8-b5d1-2a17-20ec43f30cf4/0044003199552_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 20,
      artist: "Natalia Lafourcade",
      name: "Musas Vol. II",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music128/v4/8d/f6/29/8df62958-d1bb-3ba3-b363-e8ded4a0d510/886446917184.jpg/600x600bb.jpg",
    },
  ],
};

export const seventeen = {
  year: "2017",
  albums: [
    {
      position: 1,
      artist: "Arcade Fire",
      name: "Everything Now",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/a0/f7/f1/a0f7f183-1a9d-9915-756a-c4df547911f2/886446538617.jpg/600x600bb.jpg",
    },
    {
      position: 2,
      artist: "Phoenix",
      name: "Ti Amo",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/b9/53/0f/b9530f81-16a5-813e-6c6e-9ed19c75f9a9/0044003129108_Cover.jpg/600x600bb.jpg",
    },
    {
      position: 3,
      artist: "Taylor Swift",
      name: "reputation",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/ba/16/42/ba1642a8-0c75-a83d-3b9c-8c2eba140dc5/00843930033133.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 4,
      artist: "The xx",
      name: "I See You",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music116/v4/bc/c2/4e/bcc24e7c-b389-682c-8f17-5bcb3c4e5f8f/889030016157.png/600x600bb.jpg",
    },
    {
      position: 5,
      artist: "Gorillaz",
      name: "Humanz",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music114/v4/ad/f6/74/adf6743c-1aa7-c254-a503-b4d343be2d03/190295824822.jpg/600x600bb.jpg",
    },
    {
      position: 6,
      artist: "La M.O.D.A.",
      name: "Salvavida (de las balas perdidas)",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/3e/cc/2e/3ecc2e46-820c-e085-993c-1fc8ed1b331e/25UMGIM75687.rgb.jpg/600x600bb.jpg",
    },
    {
      position: 7,
      artist: "Royal Blood",
      name: "How Did We Get So Dark",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/a7/02/5d/a7025d7b-be6c-0f9a-d646-1f12659afb86/190295812331.jpg/600x600bb.jpg",
    },
    {
      position: 8,
      artist: "Francesco Gabbani",
      name: "Magellano",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music118/v4/d0/99/06/d09906b1-3b51-3d2e-fd8f-2ab8ef372cfc/4050538293029.jpg/600x600bb.jpg",
    },
    {
      position: 9,
      artist: "Anathema",
      name: "The Optimist",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music122/v4/cb/ec/86/cbec864c-e1a2-9df7-c443-6aa7f4e4049d/802644849263.jpg/600x600bb.jpg",
    },
    {
      position: 10,
      artist: "Cashmere Cat",
      name: "9",
      cover:
        "https://is1-ssl.mzstatic.com/image/thumb/Music125/v4/c7/f6/19/c7f619bc-e19a-a7f4-2770-27df6a44b659/00602557534719.rgb.jpg/600x600bb.jpg",
    },
  ],
};
